const RendererMessages = {
  addCardFrame: 'addCardFrame',
  addAdFrame: 'addAdFrame',
  displayFrame: 'displayFrame',
  hideFrame: 'hideFrame',
  notifyFrameHidden: 'notifyFrameHidden',
  hideRenderer: 'hideRenderer',
};

export default RendererMessages;
